/* unplugin-vue-components disabled */import { render } from "./follow.vue?vue&type=template&id=5da70994&scoped=true"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"

import "./follow.vue?vue&type=style&index=0&id=5da70994&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da70994"]])

export default __exports__